import { IReportContext } from "reportengine/ReprortContextTypes";
import { DataReportRequest } from "reportengine/types";

const reportContextToRequest = async (
  report: IReportContext,
  filename: string,
  filetype: string
): Promise<DataReportRequest> => {
  return {
    TemplateName: "/templates/report_en.pptx",
    OutputFileName: `${filename}.${filetype}`,
    pages:
      report.slides?.map((slide) => {
        return {
          slideNumber: slide.index || 0,
          elements:
            slide.elements?.map((el) => {
              console.log("slide element ", el);
              if (el.type === "table") {
                return {
                  type: "table",
                  slideElement: el.slideElement,
                  rows: (el.children || []).map((ch) => {
                    return (ch.children || [])
                      .filter((ch) => {
                        return ["text", "image"].includes(ch.type || "");
                      })
                      .map((item) => {
                        if (item.type === "text") {
                          return {
                            type: "text",
                            value: item.text || "",
                            slideElement: el.slideElement || "",
                          };
                        }
                        if (item.type === "image") {
                          return {
                            type: "image",
                            value: item.imagevalue,
                            slideElement: el.slideElement || "",
                          };
                        }
                        return {
                          type: "text",
                          value: "",
                          slideElement: el.slideElement || "",
                        };
                      });
                  }),
                };
              }
              if (el.type === "text") {
                if (el.rendered) {
                  el.rendered.autofit = true;
                  return el.rendered;
                }

                return {
                  type: "text",
                  value: el.text || "",
                  slideElement: el.slideElement || "",
                  autofit: true,
                };
              }
              if (el.type === "image") {
                const original = el.elementDefinition!;
                return {
                  type: "image",
                  value: el.imagevalue,
                  slideElement: el.slideElement || "",
                  x: original.x + (el.transform?.x || 0),
                  y: original.y + (el.transform?.y || 0),
                  width: original.width + (el.transform?.width || 0),
                  height: original.height + (el.transform?.height || 0),
                };
              }
              return {
                type: "clear",
                slideElement: el.slideElement || "",
              };
            }) || [],
        };
      }) || [],
  };
};

export default reportContextToRequest;
